var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
import { IsBoolean, IsDateString, IsString } from 'class-validator';
export class UpdateCallPatientResult {
    therapistFirstName;
    therapistLastName;
    scheduledStart;
    isPatientOnboarded;
}
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], UpdateCallPatientResult.prototype, "therapistFirstName", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], UpdateCallPatientResult.prototype, "therapistLastName", void 0);
__decorate([
    IsDateString(),
    Expose(),
    __metadata("design:type", Date)
], UpdateCallPatientResult.prototype, "scheduledStart", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], UpdateCallPatientResult.prototype, "isPatientOnboarded", void 0);
//# sourceMappingURL=update-call-patient-result.dto.js.map